import React, { useState } from 'react';
import { Send, CheckCircle2 } from 'lucide-react';
import { publicApi } from '../api';
import { toast } from '../hooks/use-toast';

const Partner = () => {
  const [form, setForm] = useState({ company: '', person: '', email: '', phone: '', city: '', type: 'Retailer', volume: '', notes: '' });
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await publicApi.submitPartner(form);
      setDone(true);
      setTimeout(() => setDone(false), 5000);
      setForm({ company: '', person: '', email: '', phone: '', city: '', type: 'Retailer', volume: '', notes: '' });
    } catch (err) {
      toast({ title: 'Submission failed', description: err?.response?.data?.detail || 'Please try again.' });
    } finally {
      setSubmitting(false);
    }
  };

  const input = 'w-full px-4 py-3 rounded-2xl border-2 border-[#1a1a1a] font-brico bg-white focus:outline-none focus:ring-2 focus:ring-[#E63946]';

  return (
    <section id="partner" className="px-5 md:px-8 py-16 md:py-24 bg-[#FFD84D]">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10">
        <div>
          <div className="text-xs font-bold uppercase tracking-widest">Let’s crunch together</div>
          <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] mt-2">
            Partner<br />with us.
          </h2>
          <p className="font-brico text-lg mt-4 max-w-md">
            Retailer, cafe, gym, or corporate pantry? Tell us a bit about your business and we’ll be in touch with wholesale pricing and demo samples.
          </p>
          <ul className="mt-6 space-y-2 font-brico">
            <li>• Wholesale pricing with attractive margins</li>
            <li>• In-store activation kits &amp; sampling</li>
            <li>• Dedicated account manager</li>
            <li>• First access to new drops</li>
          </ul>
        </div>

        <form onSubmit={submit} className="bg-[#FFF4E6] rounded-3xl crunch-shadow p-6 md:p-8 space-y-3">
          {done && (
            <div className="flex items-center gap-2 bg-[#2A9D8F] text-white rounded-2xl p-3 font-brico font-semibold">
              <CheckCircle2 size={18} /> Enquiry submitted! We’ll be in touch.
            </div>
          )}
          <input required placeholder="Company / Store Name *" className={input} value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} />
          <div className="grid grid-cols-2 gap-3">
            <input required placeholder="Contact Person *" className={input} value={form.person} onChange={(e) => setForm({ ...form, person: e.target.value })} />
            <input required type="email" placeholder="Email *" className={input} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <input required placeholder="Phone *" className={input} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
            <input required placeholder="City *" className={input} value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
          </div>
          <select className={input} value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
            {['Retailer', 'Cafe', 'Gym', 'Corporate Pantry', 'Other'].map((t) => <option key={t}>{t}</option>)}
          </select>
          <input required placeholder="Estimated Monthly Volume (packs) *" className={input} value={form.volume} onChange={(e) => setForm({ ...form, volume: e.target.value })} />
          <textarea placeholder="Anything else?" rows={3} className={input} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
          <button disabled={submitting} type="submit" className="btn-chunky primary w-full justify-center">
            <Send size={16} /> {submitting ? 'Submitting…' : 'Submit Enquiry'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Partner;
